var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75,
    zoomAndPan: "magnify",
    viewBox: "0 0 56.25 56.249997",
    height: 75,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c4ec68b167"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 55.511719 0 L 55.511719 55.511719 L 0 55.511719 Z M 0 0 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c4ec68b167)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0 0 L 55.511719 0 L 55.511719 55.511719 L 0 55.511719 Z M 0 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0 0 L 55.511719 0 L 55.511719 55.511719 L 0 55.511719 Z M 0 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 531.518271 254.971642 L 522.383198 254.971642 L 522.383198 147.954514 L 531.518271 134.313484 Z M 531.518271 254.971642 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 531.518271 134.313484 L 522.383198 147.954514 L 523.438806 147.954514 L 523.438806 134.313484 Z M 531.518271 134.313484 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 41.707031 10.523438 L 41.519531 10.546875 L 41.679688 11.839844 L 41.707031 11.835938 Z M 41.707031 10.523438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 41.519531 10.546875 L 41.335938 10.628906 L 41.652344 11.851562 L 41.679688 11.839844 Z M 41.519531 10.546875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 41.335938 10.628906 L 41.164062 10.753906 L 41.628906 11.871094 L 41.652344 11.851562 Z M 41.335938 10.628906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 41.164062 10.753906 L 41.011719 10.929688 L 41.609375 11.894531 L 41.628906 11.871094 Z M 41.164062 10.753906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 41.011719 10.929688 L 40.886719 11.140625 L 41.589844 11.925781 L 41.609375 11.894531 Z M 41.011719 10.929688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 40.886719 11.140625 L 40.789062 11.386719 L 41.574219 11.960938 L 41.589844 11.925781 Z M 40.886719 11.140625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 40.789062 11.386719 L 40.722656 11.652344 L 41.566406 12 L 41.574219 11.960938 Z M 40.789062 11.386719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 40.722656 11.652344 L 40.6875 11.933594 L 41.5625 12.039062 L 41.566406 12 Z M 40.722656 11.652344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 512.842121 148.969471 L 521.936594 150.065626 L 517.795361 227.405394 L 508.700888 226.30924 Z M 512.842121 148.969471 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 41.164062 19.480469 L 41.132812 19.800781 L 40.277344 19.519531 L 40.289062 19.375 Z M 41.164062 19.480469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 41.132812 19.800781 L 41.070312 20.113281 L 40.25 19.664062 L 40.277344 19.519531 Z M 41.132812 19.800781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 41.070312 20.113281 L 40.984375 20.414062 L 40.207031 19.796875 L 40.25 19.664062 Z M 41.070312 20.113281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 40.984375 20.414062 L 40.867188 20.691406 L 40.15625 19.925781 L 40.207031 19.796875 Z M 40.984375 20.414062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 40.867188 20.691406 L 40.730469 20.941406 L 40.09375 20.039062 L 40.15625 19.925781 Z M 40.867188 20.691406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 40.730469 20.941406 L 40.570312 21.164062 L 40.019531 20.140625 L 40.09375 20.039062 Z M 40.730469 20.941406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 40.570312 21.164062 L 40.390625 21.351562 L 39.941406 20.226562 L 40.019531 20.140625 Z M 40.570312 21.164062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 40.390625 21.351562 L 40.199219 21.5 L 39.851562 20.292969 L 39.941406 20.226562 Z M 40.390625 21.351562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 40.199219 21.5 L 39.992188 21.609375 L 39.757812 20.34375 L 39.851562 20.292969 Z M 40.199219 21.5 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 39.992188 21.609375 L 39.78125 21.675781 L 39.660156 20.371094 L 39.757812 20.34375 Z M 39.992188 21.609375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 39.78125 21.675781 L 39.5625 21.695312 L 39.5625 20.382812 L 39.660156 20.371094 Z M 39.78125 21.675781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 324.984412 236.783602 L 501.149227 236.783602 L 501.149227 250.424632 L 324.984412 250.424632 Z M 324.984412 236.783602 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 22.613281 21.695312 L 22.398438 21.675781 L 22.515625 20.371094 L 22.613281 20.382812 Z M 22.613281 21.695312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 22.398438 21.675781 L 22.183594 21.609375 L 22.417969 20.34375 L 22.515625 20.371094 Z M 22.398438 21.675781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 22.183594 21.609375 L 21.980469 21.5 L 22.324219 20.292969 L 22.417969 20.34375 Z M 22.183594 21.609375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 21.980469 21.5 L 21.785156 21.351562 L 22.238281 20.226562 L 22.324219 20.292969 Z M 21.980469 21.5 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 21.785156 21.351562 L 21.609375 21.164062 L 22.15625 20.140625 L 22.238281 20.226562 Z M 21.785156 21.351562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 21.609375 21.164062 L 21.449219 20.941406 L 22.085938 20.039062 L 22.15625 20.140625 Z M 21.609375 21.164062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 21.449219 20.941406 L 21.308594 20.691406 L 22.019531 19.925781 L 22.085938 20.039062 Z M 21.449219 20.941406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 21.308594 20.691406 L 21.195312 20.414062 L 21.96875 19.796875 L 22.019531 19.925781 Z M 21.308594 20.691406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 21.195312 20.414062 L 21.105469 20.113281 L 21.929688 19.664062 L 21.96875 19.796875 Z M 21.195312 20.414062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 21.105469 20.113281 L 21.046875 19.800781 L 21.902344 19.519531 L 21.929688 19.664062 Z M 21.105469 20.113281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 21.046875 19.800781 L 21.011719 19.480469 L 21.886719 19.375 L 21.902344 19.519531 Z M 21.046875 19.800781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 317.432751 226.30924 L 308.338278 227.405394 L 304.237645 150.065626 L 313.291518 148.969471 Z M 317.432751 226.30924 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 21.488281 11.933594 L 21.457031 11.652344 L 20.613281 12 L 20.617188 12.039062 Z M 21.488281 11.933594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 21.457031 11.652344 L 21.390625 11.386719 L 20.601562 11.960938 L 20.613281 12 Z M 21.457031 11.652344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 21.390625 11.386719 L 21.292969 11.140625 L 20.585938 11.925781 L 20.601562 11.960938 Z M 21.390625 11.386719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 21.292969 11.140625 L 21.164062 10.929688 L 20.570312 11.894531 L 20.585938 11.925781 Z M 21.292969 11.140625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 21.164062 10.929688 L 21.011719 10.753906 L 20.546875 11.871094 L 20.570312 11.894531 Z M 21.164062 10.929688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 21.011719 10.753906 L 20.84375 10.628906 L 20.523438 11.851562 L 20.546875 11.871094 Z M 21.011719 10.753906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 20.84375 10.628906 L 20.660156 10.546875 L 20.5 11.839844 L 20.523438 11.851562 Z M 20.84375 10.628906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 20.660156 10.546875 L 20.472656 10.523438 L 20.472656 11.835938 L 20.5 11.839844 Z M 20.660156 10.546875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 302.735433 134.313484 L 302.735433 147.954514 L 303.750441 147.954514 L 294.655968 134.313484 Z M 302.735433 134.313484 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 294.655968 134.313484 L 303.750441 147.954514 L 303.750441 248.151127 L 294.655968 261.832755 Z M 294.655968 134.313484 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 294.655968 261.832755 L 303.750441 248.151127 L 526.930434 248.151127 L 526.930434 261.832755 Z M 294.655968 261.832755 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 522.383198 346.074235 L 531.518271 346.074235 L 531.518271 466.772991 L 522.383198 453.131961 Z M 522.383198 346.074235 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 522.383198 453.131961 L 531.518271 466.772991 L 523.438806 466.772991 L 523.438806 453.131961 Z M 522.383198 453.131961 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 41.707031 42.511719 L 41.519531 42.488281 L 41.679688 41.195312 L 41.707031 41.199219 Z M 41.707031 42.511719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 41.519531 42.488281 L 41.335938 42.40625 L 41.652344 41.183594 L 41.679688 41.195312 Z M 41.519531 42.488281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 41.335938 42.40625 L 41.164062 42.277344 L 41.628906 41.164062 L 41.652344 41.183594 Z M 41.335938 42.40625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 41.164062 42.277344 L 41.011719 42.105469 L 41.609375 41.140625 L 41.628906 41.164062 Z M 41.164062 42.277344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 41.011719 42.105469 L 40.886719 41.894531 L 41.589844 41.109375 L 41.609375 41.140625 Z M 41.011719 42.105469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 40.886719 41.894531 L 40.789062 41.648438 L 41.574219 41.074219 L 41.589844 41.109375 Z M 40.886719 41.894531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 40.789062 41.648438 L 40.722656 41.382812 L 41.566406 41.035156 L 41.574219 41.074219 Z M 40.789062 41.648438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 40.722656 41.382812 L 40.6875 41.101562 L 41.5625 40.996094 L 41.566406 41.035156 Z M 40.722656 41.382812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 521.936594 451.020849 L 512.842121 452.117003 L 508.700888 374.777235 L 517.795361 373.681081 Z M 521.936594 451.020849 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 41.164062 33.554688 L 41.132812 33.234375 L 40.277344 33.515625 L 40.289062 33.660156 Z M 41.164062 33.554688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 41.132812 33.234375 L 41.070312 32.917969 L 40.25 33.371094 L 40.277344 33.515625 Z M 41.132812 33.234375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 41.070312 32.917969 L 40.984375 32.621094 L 40.207031 33.234375 L 40.25 33.371094 Z M 41.070312 32.917969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 40.984375 32.621094 L 40.867188 32.34375 L 40.15625 33.109375 L 40.207031 33.234375 Z M 40.984375 32.621094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 40.867188 32.34375 L 40.730469 32.09375 L 40.09375 32.996094 L 40.15625 33.109375 Z M 40.867188 32.34375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 40.730469 32.09375 L 40.570312 31.871094 L 40.019531 32.894531 L 40.09375 32.996094 Z M 40.730469 32.09375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 40.570312 31.871094 L 40.390625 31.683594 L 39.941406 32.808594 L 40.019531 32.894531 Z M 40.570312 31.871094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 40.390625 31.683594 L 40.199219 31.535156 L 39.851562 32.742188 L 39.941406 32.808594 Z M 40.390625 31.683594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 40.199219 31.535156 L 39.992188 31.425781 L 39.757812 32.691406 L 39.851562 32.742188 Z M 40.199219 31.535156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 39.992188 31.425781 L 39.78125 31.359375 L 39.660156 32.664062 L 39.757812 32.691406 Z M 39.992188 31.425781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 39.78125 31.359375 L 39.5625 31.335938 L 39.5625 32.652344 L 39.660156 32.664062 Z M 39.78125 31.359375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 324.984412 350.621245 L 501.149227 350.621245 L 501.149227 364.302873 L 324.984412 364.302873 Z M 324.984412 350.621245 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 22.613281 31.335938 L 22.398438 31.359375 L 22.515625 32.664062 L 22.613281 32.652344 Z M 22.613281 31.335938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 22.398438 31.359375 L 22.183594 31.425781 L 22.417969 32.691406 L 22.515625 32.664062 Z M 22.398438 31.359375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 22.183594 31.425781 L 21.980469 31.535156 L 22.324219 32.742188 L 22.417969 32.691406 Z M 22.183594 31.425781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 21.980469 31.535156 L 21.785156 31.683594 L 22.238281 32.808594 L 22.324219 32.742188 Z M 21.980469 31.535156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 21.785156 31.683594 L 21.609375 31.871094 L 22.15625 32.894531 L 22.238281 32.808594 Z M 21.785156 31.683594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 21.609375 31.871094 L 21.449219 32.09375 L 22.085938 32.996094 L 22.15625 32.894531 Z M 21.609375 31.871094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 21.449219 32.09375 L 21.308594 32.34375 L 22.019531 33.109375 L 22.085938 32.996094 Z M 21.449219 32.09375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 21.308594 32.34375 L 21.195312 32.621094 L 21.96875 33.234375 L 22.019531 33.109375 Z M 21.308594 32.34375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 21.195312 32.621094 L 21.105469 32.917969 L 21.929688 33.371094 L 21.96875 33.234375 Z M 21.195312 32.621094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 21.105469 32.917969 L 21.046875 33.234375 L 21.902344 33.515625 L 21.929688 33.371094 Z M 21.105469 32.917969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 21.046875 33.234375 L 21.011719 33.554688 L 21.886719 33.660156 L 21.902344 33.515625 Z M 21.046875 33.234375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 308.338278 373.681081 L 317.432751 374.777235 L 313.291518 452.117003 L 304.237645 451.020849 Z M 308.338278 373.681081 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 21.488281 41.101562 L 21.457031 41.382812 L 20.613281 41.035156 L 20.617188 40.996094 Z M 21.488281 41.101562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 21.457031 41.382812 L 21.390625 41.648438 L 20.601562 41.074219 L 20.613281 41.035156 Z M 21.457031 41.382812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 21.390625 41.648438 L 21.292969 41.894531 L 20.585938 41.109375 L 20.601562 41.074219 Z M 21.390625 41.648438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 21.292969 41.894531 L 21.164062 42.105469 L 20.570312 41.140625 L 20.585938 41.109375 Z M 21.292969 41.894531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 21.164062 42.105469 L 21.011719 42.277344 L 20.546875 41.164062 L 20.570312 41.140625 Z M 21.164062 42.105469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 21.011719 42.277344 L 20.84375 42.40625 L 20.523438 41.183594 L 20.546875 41.164062 Z M 21.011719 42.277344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 20.84375 42.40625 L 20.660156 42.488281 L 20.5 41.195312 L 20.523438 41.183594 Z M 20.84375 42.40625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 20.660156 42.488281 L 20.472656 42.511719 L 20.472656 41.199219 L 20.5 41.195312 Z M 20.660156 42.488281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 302.735433 453.131961 L 302.735433 466.772991 L 294.655968 466.772991 L 303.750441 453.131961 Z M 302.735433 453.131961 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 303.750441 453.131961 L 294.655968 466.772991 L 294.655968 339.25372 L 303.750441 352.935348 Z M 303.750441 453.131961 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 303.750441 352.935348 L 294.655968 339.25372 L 526.930434 339.25372 L 526.930434 352.935348 Z M 303.750441 352.935348 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 178.295433 280.832761 L 182.030663 267.191731 L 186.334298 267.191731 L 190.110128 280.832761 Z M 178.295433 280.832761 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 190.110128 280.832761 L 186.334298 267.191731 L 188.120712 264.431046 L 191.937143 278.112675 Z M 190.110128 280.832761 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 191.937143 278.112675 L 188.120712 264.431046 L 197.499387 264.431046 L 188.364314 278.112675 Z M 191.937143 278.112675 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 188.364314 278.112675 L 197.499387 264.431046 L 197.499387 333.894744 L 188.364314 320.253714 Z M 188.364314 278.112675 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 188.364314 320.253714 L 197.499387 333.894744 L 187.349306 333.894744 L 183.573476 320.253714 Z M 188.364314 320.253714 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 183.573476 320.253714 L 187.349306 333.894744 L 185.522291 336.61483 L 181.746461 322.9738 Z M 183.573476 320.253714 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 181.746461 322.9738 L 185.522291 336.61483 L 177.483427 336.61483 L 181.259257 322.9738 Z M 181.746461 322.9738 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 181.259257 322.9738 L 177.483427 336.61483 L 175.656412 333.894744 L 179.432242 320.253714 Z M 181.259257 322.9738 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 179.432242 320.253714 L 175.656412 333.894744 L 171.393378 333.894744 L 167.617547 320.253714 Z M 179.432242 320.253714 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 167.617547 320.253714 L 171.393378 333.894744 L 169.566363 336.61483 L 165.790533 322.9738 Z M 167.617547 320.253714 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 165.790533 322.9738 L 169.566363 336.61483 L 161.568099 336.61483 L 165.303329 322.9738 Z M 165.790533 322.9738 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 165.303329 322.9738 L 161.568099 336.61483 L 159.741084 333.894744 L 163.516914 320.253714 Z M 165.303329 322.9738 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 163.516914 320.253714 L 159.741084 333.894744 L 155.437449 333.894744 L 151.661619 320.253714 Z M 163.516914 320.253714 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 151.661619 320.253714 L 155.437449 333.894744 L 153.610435 336.61483 L 149.875205 322.9738 Z M 151.661619 320.253714 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 149.875205 322.9738 L 153.610435 336.61483 L 145.612171 336.61483 L 149.388001 322.9738 Z M 149.875205 322.9738 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 149.388001 322.9738 L 145.612171 336.61483 L 143.785156 333.894744 L 147.560986 320.253714 Z M 149.388001 322.9738 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 147.560986 320.253714 L 143.785156 333.894744 L 134.447081 333.894744 L 143.541554 320.253714 Z M 147.560986 320.253714 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 143.541554 320.253714 L 134.447081 333.894744 L 134.447081 267.191731 L 143.541554 280.832761 Z M 143.541554 320.253714 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 143.541554 280.832761 L 134.447081 267.191731 L 138.507113 267.191731 L 142.282944 280.832761 Z M 143.541554 280.832761 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 142.282944 280.832761 L 138.507113 267.191731 L 140.334128 264.431046 L 144.109958 278.112675 Z M 142.282944 280.832761 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 144.109958 278.112675 L 140.334128 264.431046 L 148.332392 264.431046 L 144.556562 278.112675 Z M 144.109958 278.112675 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 144.556562 278.112675 L 148.332392 264.431046 L 150.159407 267.191731 L 146.383577 280.832761 Z M 144.556562 278.112675 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 146.383577 280.832761 L 150.159407 267.191731 L 154.422441 267.191731 L 158.198272 280.832761 Z M 146.383577 280.832761 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 158.198272 280.832761 L 154.422441 267.191731 L 156.249456 264.431046 L 160.025286 278.112675 Z M 158.198272 280.832761 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 160.025286 278.112675 L 156.249456 264.431046 L 164.288321 264.431046 L 160.51249 278.112675 Z M 160.025286 278.112675 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 160.51249 278.112675 L 164.288321 264.431046 L 166.115335 267.191731 L 162.339505 280.832761 Z M 160.51249 278.112675 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 162.339505 280.832761 L 166.115335 267.191731 L 170.37837 267.191731 L 174.1542 280.832761 Z M 162.339505 280.832761 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 174.1542 280.832761 L 170.37837 267.191731 L 172.205384 264.431046 L 175.981215 278.112675 Z M 174.1542 280.832761 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 175.981215 278.112675 L 172.205384 264.431046 L 180.244249 264.431046 L 176.468418 278.112675 Z M 175.981215 278.112675 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 176.468418 278.112675 L 180.244249 264.431046 L 182.030663 267.191731 L 178.295433 280.832761 Z M 176.468418 278.112675 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 264.286924 157.089132 L 273.381397 170.730162 L 273.381397 430.356313 L 264.286924 443.997343 Z M 264.286924 157.089132 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 264.286924 443.997343 L 273.381397 430.356313 L 294.655968 430.356313 L 303.750441 443.997343 Z M 264.286924 443.997343 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 303.750441 443.997343 L 294.655968 430.356313 L 294.655968 170.730162 L 303.750441 157.089132 Z M 303.750441 443.997343 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 303.750441 157.089132 L 294.655968 170.730162 L 273.381397 170.730162 L 264.286924 157.089132 Z M 303.750441 157.089132 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 273.381397 274.337033 L 264.286924 260.696003 L 303.750441 260.696003 L 294.655968 274.337033 Z M 273.381397 274.337033 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 294.655968 274.337033 L 303.750441 260.696003 L 303.750441 340.390472 L 294.655968 326.749442 Z M 294.655968 274.337033 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 294.655968 326.749442 L 303.750441 340.390472 L 264.286924 340.390472 L 273.381397 326.749442 Z M 294.655968 326.749442 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 273.381397 326.749442 L 264.286924 340.390472 L 264.286924 260.696003 L 273.381397 274.337033 Z M 273.381397 326.749442 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 197.093384 254.76865 L 193.317554 241.12762 L 268.468758 241.12762 L 264.692927 254.76865 Z M 197.093384 254.76865 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 264.692927 254.76865 L 268.468758 241.12762 L 273.381397 248.516512 L 264.286924 254.200274 Z M 264.692927 254.76865 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 264.286924 254.200274 L 273.381397 248.516512 L 273.381397 352.529365 L 264.286924 346.886201 Z M 264.286924 254.200274 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 264.286924 346.886201 L 273.381397 352.529365 L 268.468758 359.958854 L 264.692927 346.317825 Z M 264.286924 346.886201 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 264.692927 346.317825 L 268.468758 359.958854 L 193.317554 359.958854 L 197.093384 346.317825 Z M 264.692927 346.317825 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 197.093384 346.317825 L 193.317554 359.958854 L 188.364314 352.529365 L 197.499387 346.886201 Z M 197.093384 346.317825 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 197.499387 346.886201 L 188.364314 352.529365 L 188.364314 248.516512 L 197.499387 254.200274 Z M 197.499387 346.886201 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 197.499387 254.200274 L 188.364314 248.516512 L 193.317554 241.12762 L 197.093384 254.76865 Z M 197.499387 254.200274 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 195.225769 267.394723 L 266.560542 267.394723 L 266.560542 281.076351 L 195.225769 281.076351 Z M 195.225769 267.394723 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 195.225769 320.010124 L 266.560542 320.010124 L 266.560542 333.651154 L 195.225769 333.651154 Z M 195.225769 320.010124 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 9.746094 21.136719 L 9.636719 21.46875 L 10.445312 21.972656 L 10.511719 21.777344 Z M 9.746094 21.136719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 9.636719 21.46875 L 9.558594 21.8125 L 10.398438 22.179688 L 10.445312 21.972656 Z M 9.636719 21.46875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 9.558594 21.8125 L 9.503906 22.171875 L 10.367188 22.394531 L 10.398438 22.179688 Z M 9.558594 21.8125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 9.503906 22.171875 L 9.472656 22.539062 L 10.351562 22.613281 L 10.367188 22.394531 Z M 9.503906 22.171875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 9.472656 22.539062 L 9.472656 22.90625 L 10.351562 22.832031 L 10.351562 22.613281 Z M 9.472656 22.539062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 9.472656 22.90625 L 9.503906 23.269531 L 10.367188 23.050781 L 10.351562 22.832031 Z M 9.472656 22.90625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 9.503906 23.269531 L 9.558594 23.628906 L 10.398438 23.261719 L 10.367188 23.050781 Z M 9.503906 23.269531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 9.558594 23.628906 L 9.636719 23.976562 L 10.445312 23.46875 L 10.398438 23.261719 Z M 9.558594 23.628906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 9.636719 23.976562 L 9.746094 24.308594 L 10.511719 23.667969 L 10.445312 23.46875 Z M 9.636719 23.976562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 9.703125 23.820312 L 9.613281 24.410156 L 10.472656 24.671875 L 10.550781 24.15625 Z M 9.703125 23.820312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 9.613281 24.410156 L 9.542969 25.007812 L 10.410156 25.195312 L 10.472656 24.671875 Z M 9.613281 24.410156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 9.542969 25.007812 L 9.496094 25.609375 L 10.371094 25.722656 L 10.410156 25.195312 Z M 9.542969 25.007812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 9.496094 25.609375 L 9.472656 26.214844 L 10.351562 26.25 L 10.371094 25.722656 Z M 9.496094 25.609375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 9.472656 26.214844 L 9.472656 26.820312 L 10.351562 26.78125 L 10.351562 26.25 Z M 9.472656 26.214844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 9.472656 26.820312 L 9.496094 27.425781 L 10.371094 27.3125 L 10.351562 26.78125 Z M 9.472656 26.820312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 9.496094 27.425781 L 9.542969 28.027344 L 10.410156 27.839844 L 10.371094 27.3125 Z M 9.496094 27.425781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 9.542969 28.027344 L 9.613281 28.625 L 10.472656 28.363281 L 10.410156 27.839844 Z M 9.542969 28.027344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 9.613281 28.625 L 9.703125 29.214844 L 10.550781 28.878906 L 10.472656 28.363281 Z M 9.613281 28.625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 9.746094 28.726562 L 9.636719 29.058594 L 10.445312 29.566406 L 10.511719 29.367188 Z M 9.746094 28.726562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 9.636719 29.058594 L 9.558594 29.40625 L 10.398438 29.769531 L 10.445312 29.566406 Z M 9.636719 29.058594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 9.558594 29.40625 L 9.503906 29.761719 L 10.367188 29.984375 L 10.398438 29.769531 Z M 9.558594 29.40625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 9.503906 29.761719 L 9.472656 30.128906 L 10.351562 30.203125 L 10.367188 29.984375 Z M 9.503906 29.761719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 9.472656 30.128906 L 9.472656 30.496094 L 10.351562 30.421875 L 10.351562 30.203125 Z M 9.472656 30.128906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 9.472656 30.496094 L 9.503906 30.863281 L 10.367188 30.640625 L 10.351562 30.421875 Z M 9.472656 30.496094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 9.503906 30.863281 L 9.558594 31.21875 L 10.398438 30.855469 L 10.367188 30.640625 Z M 9.503906 30.863281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 9.558594 31.21875 L 9.636719 31.566406 L 10.445312 31.0625 L 10.398438 30.855469 Z M 9.558594 31.21875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 9.636719 31.566406 L 9.746094 31.898438 L 10.511719 31.257812 L 10.445312 31.0625 Z M 9.636719 31.566406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 17.375 24.308594 L 17.484375 23.976562 L 16.675781 23.46875 L 16.609375 23.667969 Z M 17.375 24.308594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 17.484375 23.976562 L 17.566406 23.628906 L 16.722656 23.261719 L 16.675781 23.46875 Z M 17.484375 23.976562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 17.566406 23.628906 L 17.621094 23.269531 L 16.753906 23.050781 L 16.722656 23.261719 Z M 17.566406 23.628906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 17.621094 23.269531 L 17.648438 22.90625 L 16.773438 22.832031 L 16.753906 23.050781 Z M 17.621094 23.269531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 17.648438 22.90625 L 17.648438 22.539062 L 16.773438 22.613281 L 16.773438 22.832031 Z M 17.648438 22.90625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 17.648438 22.539062 L 17.621094 22.171875 L 16.753906 22.394531 L 16.773438 22.613281 Z M 17.648438 22.539062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 17.621094 22.171875 L 17.566406 21.8125 L 16.722656 22.179688 L 16.753906 22.394531 Z M 17.621094 22.171875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 17.566406 21.8125 L 17.484375 21.46875 L 16.675781 21.972656 L 16.722656 22.179688 Z M 17.566406 21.8125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 17.484375 21.46875 L 17.375 21.136719 L 16.609375 21.777344 L 16.675781 21.972656 Z M 17.484375 21.46875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 17.417969 29.214844 L 17.507812 28.625 L 16.652344 28.363281 L 16.570312 28.878906 Z M 17.417969 29.214844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 17.507812 28.625 L 17.578125 28.027344 L 16.710938 27.839844 L 16.652344 28.363281 Z M 17.507812 28.625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 17.578125 28.027344 L 17.625 27.425781 L 16.75 27.3125 L 16.710938 27.839844 Z M 17.578125 28.027344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 17.625 27.425781 L 17.648438 26.820312 L 16.773438 26.78125 L 16.75 27.3125 Z M 17.625 27.425781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 17.648438 26.820312 L 17.648438 26.214844 L 16.773438 26.25 L 16.773438 26.78125 Z M 17.648438 26.820312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 17.648438 26.214844 L 17.625 25.609375 L 16.75 25.722656 L 16.773438 26.25 Z M 17.648438 26.214844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 17.625 25.609375 L 17.578125 25.007812 L 16.710938 25.195312 L 16.75 25.722656 Z M 17.625 25.609375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 17.578125 25.007812 L 17.507812 24.410156 L 16.652344 24.671875 L 16.710938 25.195312 Z M 17.578125 25.007812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 17.507812 24.410156 L 17.417969 23.820312 L 16.570312 24.15625 L 16.652344 24.671875 Z M 17.507812 24.410156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 17.375 31.898438 L 17.484375 31.566406 L 16.675781 31.0625 L 16.609375 31.257812 Z M 17.375 31.898438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 17.484375 31.566406 L 17.566406 31.21875 L 16.722656 30.855469 L 16.675781 31.0625 Z M 17.484375 31.566406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 17.566406 31.21875 L 17.621094 30.863281 L 16.753906 30.640625 L 16.722656 30.855469 Z M 17.566406 31.21875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 17.621094 30.863281 L 17.648438 30.496094 L 16.773438 30.421875 L 16.753906 30.640625 Z M 17.621094 30.863281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 17.648438 30.496094 L 17.648438 30.128906 L 16.773438 30.203125 L 16.773438 30.421875 Z M 17.648438 30.496094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 17.648438 30.128906 L 17.621094 29.761719 L 16.753906 29.984375 L 16.773438 30.203125 Z M 17.648438 30.128906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 17.621094 29.761719 L 17.566406 29.40625 L 16.722656 29.769531 L 16.753906 29.984375 Z M 17.621094 29.761719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 17.566406 29.40625 L 17.484375 29.058594 L 16.675781 29.566406 L 16.722656 29.769531 Z M 17.566406 29.40625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 17.484375 29.058594 L 17.375 28.726562 L 16.609375 29.367188 L 16.675781 29.566406 Z M 17.484375 29.058594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 271.310781 333.894744 L 275.086611 320.253714 L 276.913626 322.9738 L 273.137795 336.61483 Z M 271.310781 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 273.137795 336.61483 L 276.913626 322.9738 L 277.400829 322.9738 L 281.17666 336.61483 Z M 273.137795 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 281.17666 336.61483 L 277.400829 322.9738 L 279.227844 320.253714 L 282.963074 333.894744 Z M 281.17666 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 282.963074 333.894744 L 279.227844 320.253714 L 291.042539 320.253714 L 287.266709 333.894744 Z M 282.963074 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 287.266709 333.894744 L 291.042539 320.253714 L 292.869554 322.9738 L 289.093723 336.61483 Z M 287.266709 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 289.093723 336.61483 L 292.869554 322.9738 L 293.316157 322.9738 L 297.091988 336.61483 Z M 289.093723 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 297.091988 336.61483 L 293.316157 322.9738 L 295.143172 320.253714 L 298.919002 333.894744 Z M 297.091988 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 298.919002 333.894744 L 295.143172 320.253714 L 306.957867 320.253714 L 303.182037 333.894744 Z M 298.919002 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 303.182037 333.894744 L 306.957867 320.253714 L 308.784882 322.9738 L 305.009051 336.61483 Z M 303.182037 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 305.009051 336.61483 L 308.784882 322.9738 L 309.272086 322.9738 L 313.047916 336.61483 Z M 305.009051 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 313.047916 336.61483 L 309.272086 322.9738 L 311.0991 320.253714 L 314.874931 333.894744 Z M 313.047916 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 314.874931 333.894744 L 311.0991 320.253714 L 322.913795 320.253714 L 319.137965 333.894744 Z M 314.874931 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 319.137965 333.894744 L 322.913795 320.253714 L 324.74081 322.9738 L 320.964979 336.61483 Z M 319.137965 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 320.964979 336.61483 L 324.74081 322.9738 L 325.228014 322.9738 L 328.963244 336.61483 Z M 320.964979 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 328.963244 336.61483 L 325.228014 322.9738 L 327.014428 320.253714 L 330.790258 333.894744 Z M 328.963244 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 330.790258 333.894744 L 327.014428 320.253714 L 338.869723 320.253714 L 335.093893 333.894744 Z M 330.790258 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 335.093893 333.894744 L 338.869723 320.253714 L 340.656138 322.9738 L 336.880307 336.61483 Z M 335.093893 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 336.880307 336.61483 L 340.656138 322.9738 L 341.143342 322.9738 L 344.919172 336.61483 Z M 336.880307 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 344.919172 336.61483 L 341.143342 322.9738 L 342.970356 320.253714 L 346.746187 333.894744 Z M 344.919172 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 346.746187 333.894744 L 342.970356 320.253714 L 354.785051 320.253714 L 351.009221 333.894744 Z M 346.746187 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 351.009221 333.894744 L 354.785051 320.253714 L 356.612066 322.9738 L 352.836236 336.61483 Z M 351.009221 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 352.836236 336.61483 L 356.612066 322.9738 L 357.09927 322.9738 L 360.8751 336.61483 Z M 352.836236 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 360.8751 336.61483 L 357.09927 322.9738 L 358.926284 320.253714 L 362.702115 333.894744 Z M 360.8751 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 362.702115 333.894744 L 358.926284 320.253714 L 370.740979 320.253714 L 366.965149 333.894744 Z M 362.702115 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 366.965149 333.894744 L 370.740979 320.253714 L 372.567994 322.9738 L 368.792164 336.61483 Z M 366.965149 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 368.792164 336.61483 L 372.567994 322.9738 L 373.014598 322.9738 L 376.790428 336.61483 Z M 368.792164 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 376.790428 336.61483 L 373.014598 322.9738 L 374.841612 320.253714 L 378.617443 333.894744 Z M 376.790428 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 378.617443 333.894744 L 374.841612 320.253714 L 386.656307 320.253714 L 382.880477 333.894744 Z M 378.617443 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 382.880477 333.894744 L 386.656307 320.253714 L 388.483322 322.9738 L 384.707492 336.61483 Z M 382.880477 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 384.707492 336.61483 L 388.483322 322.9738 L 388.970526 322.9738 L 392.746356 336.61483 Z M 384.707492 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 392.746356 336.61483 L 388.970526 322.9738 L 390.797541 320.253714 L 394.573371 333.894744 Z M 392.746356 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 394.573371 333.894744 L 390.797541 320.253714 L 402.612236 320.253714 L 398.836405 333.894744 Z M 394.573371 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 398.836405 333.894744 L 402.612236 320.253714 L 404.43925 322.9738 L 400.66342 336.61483 Z M 398.836405 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 400.66342 336.61483 L 404.43925 322.9738 L 404.926454 322.9738 L 408.702284 336.61483 Z M 400.66342 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 408.702284 336.61483 L 404.926454 322.9738 L 406.753469 320.253714 L 410.529299 333.894744 Z M 408.702284 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 410.529299 333.894744 L 406.753469 320.253714 L 418.568164 320.253714 L 414.792333 333.894744 Z M 410.529299 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 414.792333 333.894744 L 418.568164 320.253714 L 420.395178 322.9738 L 416.619348 336.61483 Z M 414.792333 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 416.619348 336.61483 L 420.395178 322.9738 L 420.841782 322.9738 L 424.617612 336.61483 Z M 416.619348 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 424.617612 336.61483 L 420.841782 322.9738 L 422.668797 320.253714 L 426.444627 333.894744 Z M 424.617612 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 426.444627 333.894744 L 422.668797 320.253714 L 434.483492 320.253714 L 430.707661 333.894744 Z M 426.444627 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 430.707661 333.894744 L 434.483492 320.253714 L 436.310506 322.9738 L 432.534676 336.61483 Z M 430.707661 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 432.534676 336.61483 L 436.310506 322.9738 L 436.79771 322.9738 L 440.573541 336.61483 Z M 432.534676 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 440.573541 336.61483 L 436.79771 322.9738 L 438.624725 320.253714 L 442.400555 333.894744 Z M 440.573541 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 442.400555 333.894744 L 438.624725 320.253714 L 450.43942 320.253714 L 446.663589 333.894744 Z M 442.400555 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 446.663589 333.894744 L 450.43942 320.253714 L 452.266434 322.9738 L 448.490604 336.61483 Z M 446.663589 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 448.490604 336.61483 L 452.266434 322.9738 L 452.753638 322.9738 L 456.529469 336.61483 Z M 448.490604 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 456.529469 336.61483 L 452.753638 322.9738 L 454.540053 320.253714 L 458.315883 333.894744 Z M 456.529469 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 458.315883 333.894744 L 454.540053 320.253714 L 466.395348 320.253714 L 462.619518 333.894744 Z M 458.315883 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 462.619518 333.894744 L 466.395348 320.253714 L 468.181762 322.9738 L 464.446532 336.61483 Z M 462.619518 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 464.446532 336.61483 L 468.181762 322.9738 L 468.668966 322.9738 L 472.444797 336.61483 Z M 464.446532 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 472.444797 336.61483 L 468.668966 322.9738 L 470.495981 320.253714 L 474.271811 333.894744 Z M 472.444797 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 474.271811 333.894744 L 470.495981 320.253714 L 482.310676 320.253714 L 478.534846 333.894744 Z M 474.271811 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 478.534846 333.894744 L 482.310676 320.253714 L 484.137691 322.9738 L 480.36186 336.61483 Z M 478.534846 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 480.36186 336.61483 L 484.137691 322.9738 L 484.624894 322.9738 L 488.400725 336.61483 Z M 480.36186 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 488.400725 336.61483 L 484.624894 322.9738 L 486.451909 320.253714 L 490.227739 333.894744 Z M 488.400725 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 490.227739 333.894744 L 486.451909 320.253714 L 498.266604 320.253714 L 494.490774 333.894744 Z M 490.227739 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 494.490774 333.894744 L 498.266604 320.253714 L 500.093619 322.9738 L 496.317788 336.61483 Z M 494.490774 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 496.317788 336.61483 L 500.093619 322.9738 L 500.540222 322.9738 L 504.316053 336.61483 Z M 496.317788 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 504.316053 336.61483 L 500.540222 322.9738 L 502.367237 320.253714 L 506.143067 333.894744 Z M 504.316053 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 506.143067 333.894744 L 502.367237 320.253714 L 514.181932 320.253714 L 510.446702 333.894744 Z M 506.143067 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 510.446702 333.894744 L 514.181932 320.253714 L 516.008947 322.9738 L 512.233116 336.61483 Z M 510.446702 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 512.233116 336.61483 L 516.008947 322.9738 L 516.496151 322.9738 L 520.271981 336.61483 Z M 512.233116 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 520.271981 336.61483 L 516.496151 322.9738 L 518.323165 320.253714 L 522.098996 333.894744 Z M 520.271981 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 522.098996 333.894744 L 518.323165 320.253714 L 530.13786 320.253714 L 526.36203 333.894744 Z M 522.098996 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 526.36203 333.894744 L 530.13786 320.253714 L 531.964875 322.9738 L 528.189045 336.61483 Z M 526.36203 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 528.189045 336.61483 L 531.964875 322.9738 L 532.452079 322.9738 L 536.227909 336.61483 Z M 528.189045 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 536.227909 336.61483 L 532.452079 322.9738 L 534.279093 320.253714 L 538.054924 333.894744 Z M 536.227909 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 538.054924 333.894744 L 534.279093 320.253714 L 546.093788 320.253714 L 542.317958 333.894744 Z M 538.054924 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 542.317958 333.894744 L 546.093788 320.253714 L 547.920803 322.9738 L 544.144973 336.61483 Z M 542.317958 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 544.144973 336.61483 L 547.920803 322.9738 L 548.367407 322.9738 L 552.143237 336.61483 Z M 544.144973 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 552.143237 336.61483 L 548.367407 322.9738 L 550.194421 320.253714 L 553.970252 333.894744 Z M 552.143237 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 553.970252 333.894744 L 550.194421 320.253714 L 562.049717 320.253714 L 558.233286 333.894744 Z M 553.970252 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 558.233286 333.894744 L 562.049717 320.253714 L 563.836131 322.9738 L 560.060301 336.61483 Z M 558.233286 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 560.060301 336.61483 L 563.836131 322.9738 L 564.323335 322.9738 L 568.099165 336.61483 Z M 560.060301 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 568.099165 336.61483 L 564.323335 322.9738 L 566.15035 320.253714 L 569.92618 333.894744 Z M 568.099165 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 569.92618 333.894744 L 566.15035 320.253714 L 577.965044 320.253714 L 574.189214 333.894744 Z M 569.92618 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 574.189214 333.894744 L 577.965044 320.253714 L 579.792059 322.9738 L 576.016229 336.61483 Z M 574.189214 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 576.016229 336.61483 L 579.792059 322.9738 L 580.279263 322.9738 L 584.055093 336.61483 Z M 576.016229 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 584.055093 336.61483 L 580.279263 322.9738 L 582.106278 320.253714 L 585.841508 333.894744 Z M 584.055093 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 585.841508 333.894744 L 582.106278 320.253714 L 593.920973 320.253714 L 590.145142 333.894744 Z M 585.841508 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 590.145142 333.894744 L 593.920973 320.253714 L 595.747987 322.9738 L 591.972157 336.61483 Z M 590.145142 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 591.972157 336.61483 L 595.747987 322.9738 L 596.194591 322.9738 L 599.970421 336.61483 Z M 591.972157 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 599.970421 336.61483 L 596.194591 322.9738 L 598.021606 320.253714 L 601.797436 333.894744 Z M 599.970421 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 601.797436 333.894744 L 598.021606 320.253714 L 609.836301 320.253714 L 606.06047 333.894744 Z M 601.797436 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 606.06047 333.894744 L 609.836301 320.253714 L 611.663315 322.9738 L 607.887485 336.61483 Z M 606.06047 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 607.887485 336.61483 L 611.663315 322.9738 L 612.150519 322.9738 L 615.926349 336.61483 Z M 607.887485 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 615.926349 336.61483 L 612.150519 322.9738 L 613.977534 320.253714 L 617.753364 333.894744 Z M 615.926349 336.61483 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 617.753364 333.894744 L 613.977534 320.253714 L 612.678323 320.253714 L 621.772796 333.894744 Z M 617.753364 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 621.772796 333.894744 L 612.678323 320.253714 L 612.678323 280.832761 L 621.772796 267.191731 Z M 621.772796 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 621.772796 267.191731 L 612.678323 280.832761 L 608.699491 280.832761 L 612.475322 267.191731 Z M 621.772796 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 612.475322 267.191731 L 608.699491 280.832761 L 606.872477 278.112675 L 610.648307 264.431046 Z M 612.475322 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 610.648307 264.431046 L 606.872477 278.112675 L 606.385273 278.112675 L 602.609442 264.431046 Z M 610.648307 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 602.609442 264.431046 L 606.385273 278.112675 L 604.558258 280.832761 L 600.782428 267.191731 Z M 602.609442 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 600.782428 267.191731 L 604.558258 280.832761 L 592.743563 280.832761 L 596.519394 267.191731 Z M 600.782428 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 596.519394 267.191731 L 592.743563 280.832761 L 590.916549 278.112675 L 594.692379 264.431046 Z M 596.519394 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 594.692379 264.431046 L 590.916549 278.112675 L 590.429345 278.112675 L 586.653514 264.431046 Z M 594.692379 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 586.653514 264.431046 L 590.429345 278.112675 L 588.60233 280.832761 L 584.8671 267.191731 Z M 586.653514 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 584.8671 267.191731 L 588.60233 280.832761 L 576.787635 280.832761 L 580.563465 267.191731 Z M 584.8671 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 580.563465 267.191731 L 576.787635 280.832761 L 574.96062 278.112675 L 578.736451 264.431046 Z M 580.563465 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 578.736451 264.431046 L 574.96062 278.112675 L 574.514017 278.112675 L 570.738186 264.431046 Z M 578.736451 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 570.738186 264.431046 L 574.514017 278.112675 L 572.687002 280.832761 L 568.911172 267.191731 Z M 570.738186 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 568.911172 267.191731 L 572.687002 280.832761 L 560.872307 280.832761 L 564.648137 267.191731 Z M 568.911172 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 564.648137 267.191731 L 560.872307 280.832761 L 559.045292 278.112675 L 562.821123 264.431046 Z M 564.648137 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 562.821123 264.431046 L 559.045292 278.112675 L 558.558089 278.112675 L 554.782258 264.431046 Z M 562.821123 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 554.782258 264.431046 L 558.558089 278.112675 L 556.731074 280.832761 L 552.955243 267.191731 Z M 554.782258 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 552.955243 267.191731 L 556.731074 280.832761 L 544.916379 280.832761 L 548.692209 267.191731 Z M 552.955243 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 548.692209 267.191731 L 544.916379 280.832761 L 543.089364 278.112675 L 546.865195 264.431046 Z M 548.692209 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 546.865195 264.431046 L 543.089364 278.112675 L 542.60216 278.112675 L 538.86693 264.431046 Z M 546.865195 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 538.86693 264.431046 L 542.60216 278.112675 L 540.815746 280.832761 L 537.039916 267.191731 Z M 538.86693 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 537.039916 267.191731 L 540.815746 280.832761 L 528.960451 280.832761 L 532.736281 267.191731 Z M 537.039916 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 532.736281 267.191731 L 528.960451 280.832761 L 527.174036 278.112675 L 530.949867 264.431046 Z M 532.736281 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 530.949867 264.431046 L 527.174036 278.112675 L 526.686832 278.112675 L 522.911002 264.431046 Z M 530.949867 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 522.911002 264.431046 L 526.686832 278.112675 L 524.859818 280.832761 L 521.083987 267.191731 Z M 522.911002 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 521.083987 267.191731 L 524.859818 280.832761 L 513.045123 280.832761 L 516.820953 267.191731 Z M 521.083987 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 516.820953 267.191731 L 513.045123 280.832761 L 511.218108 278.112675 L 514.993938 264.431046 Z M 516.820953 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 514.993938 264.431046 L 511.218108 278.112675 L 510.730904 278.112675 L 506.955074 264.431046 Z M 514.993938 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 506.955074 264.431046 L 510.730904 278.112675 L 508.90389 280.832761 L 505.128059 267.191731 Z M 506.955074 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 505.128059 267.191731 L 508.90389 280.832761 L 497.089195 280.832761 L 500.865025 267.191731 Z M 505.128059 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 500.865025 267.191731 L 497.089195 280.832761 L 495.26218 278.112675 L 499.03801 264.431046 Z M 500.865025 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 499.03801 264.431046 L 495.26218 278.112675 L 494.815576 278.112675 L 491.039746 264.431046 Z M 499.03801 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 491.039746 264.431046 L 494.815576 278.112675 L 492.988562 280.832761 L 489.212731 267.191731 Z M 491.039746 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 489.212731 267.191731 L 492.988562 280.832761 L 481.133266 280.832761 L 484.949697 267.191731 Z M 489.212731 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 484.949697 267.191731 L 481.133266 280.832761 L 479.346852 278.112675 L 483.122682 264.431046 Z M 484.949697 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 483.122682 264.431046 L 479.346852 278.112675 L 478.859648 278.112675 L 475.083818 264.431046 Z M 483.122682 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 475.083818 264.431046 L 478.859648 278.112675 L 477.032633 280.832761 L 473.256803 267.191731 Z M 475.083818 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 473.256803 267.191731 L 477.032633 280.832761 L 465.217939 280.832761 L 468.993769 267.191731 Z M 473.256803 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 468.993769 267.191731 L 465.217939 280.832761 L 463.390924 278.112675 L 467.166754 264.431046 Z M 468.993769 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 467.166754 264.431046 L 463.390924 278.112675 L 462.90372 278.112675 L 459.12789 264.431046 Z M 467.166754 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 459.12789 264.431046 L 462.90372 278.112675 L 461.076705 280.832761 L 457.300875 267.191731 Z M 459.12789 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 457.300875 267.191731 L 461.076705 280.832761 L 449.26201 280.832761 L 453.037841 267.191731 Z M 457.300875 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 453.037841 267.191731 L 449.26201 280.832761 L 447.434996 278.112675 L 451.210826 264.431046 Z M 453.037841 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 451.210826 264.431046 L 447.434996 278.112675 L 446.988392 278.112675 L 443.212562 264.431046 Z M 451.210826 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 443.212562 264.431046 L 446.988392 278.112675 L 445.161377 280.832761 L 441.385547 267.191731 Z M 443.212562 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 441.385547 267.191731 L 445.161377 280.832761 L 433.346682 280.832761 L 437.122513 267.191731 Z M 441.385547 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 437.122513 267.191731 L 433.346682 280.832761 L 431.519668 278.112675 L 435.295498 264.431046 Z M 437.122513 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 435.295498 264.431046 L 431.519668 278.112675 L 431.032464 278.112675 L 427.256634 264.431046 Z M 435.295498 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 427.256634 264.431046 L 431.032464 278.112675 L 429.205449 280.832761 L 425.429619 267.191731 Z M 427.256634 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 425.429619 267.191731 L 429.205449 280.832761 L 417.390754 280.832761 L 421.166585 267.191731 Z M 425.429619 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 421.166585 267.191731 L 417.390754 280.832761 L 415.56374 278.112675 L 419.33957 264.431046 Z M 421.166585 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 419.33957 264.431046 L 415.56374 278.112675 L 415.076536 278.112675 L 411.300705 264.431046 Z M 419.33957 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 411.300705 264.431046 L 415.076536 278.112675 L 413.290121 280.832761 L 409.514291 267.191731 Z M 411.300705 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 409.514291 267.191731 L 413.290121 280.832761 L 401.434826 280.832761 L 405.210656 267.191731 Z M 409.514291 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 405.210656 267.191731 L 401.434826 280.832761 L 399.648412 278.112675 L 403.383642 264.431046 Z M 405.210656 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 403.383642 264.431046 L 399.648412 278.112675 L 399.161208 278.112675 L 395.385377 264.431046 Z M 403.383642 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 395.385377 264.431046 L 399.161208 278.112675 L 397.334193 280.832761 L 393.558363 267.191731 Z M 395.385377 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 393.558363 267.191731 L 397.334193 280.832761 L 385.519498 280.832761 L 389.295329 267.191731 Z M 393.558363 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 389.295329 267.191731 L 385.519498 280.832761 L 383.692483 278.112675 L 387.468314 264.431046 Z M 389.295329 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 387.468314 264.431046 L 383.692483 278.112675 L 383.20528 278.112675 L 379.429449 264.431046 Z M 387.468314 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 379.429449 264.431046 L 383.20528 278.112675 L 381.378265 280.832761 L 377.602435 267.191731 Z M 379.429449 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 377.602435 267.191731 L 381.378265 280.832761 L 369.56357 280.832761 L 373.3394 267.191731 Z M 377.602435 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 373.3394 267.191731 L 369.56357 280.832761 L 367.736555 278.112675 L 371.512386 264.431046 Z M 373.3394 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 371.512386 264.431046 L 367.736555 278.112675 L 367.289952 278.112675 L 363.473521 264.431046 Z M 371.512386 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 363.473521 264.431046 L 367.289952 278.112675 L 365.462937 280.832761 L 361.687107 267.191731 Z M 363.473521 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 361.687107 267.191731 L 365.462937 280.832761 L 353.648242 280.832761 L 357.383472 267.191731 Z M 361.687107 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 357.383472 267.191731 L 353.648242 280.832761 L 351.780627 278.112675 L 355.597058 264.431046 Z M 357.383472 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 355.597058 264.431046 L 351.780627 278.112675 L 351.334023 278.112675 L 347.558193 264.431046 Z M 355.597058 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 347.558193 264.431046 L 351.334023 278.112675 L 349.507009 280.832761 L 345.731178 267.191731 Z M 347.558193 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 345.731178 267.191731 L 349.507009 280.832761 L 337.692314 280.832761 L 341.468144 267.191731 Z M 345.731178 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 341.468144 267.191731 L 337.692314 280.832761 L 335.865299 278.112675 L 339.64113 264.431046 Z M 341.468144 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 339.64113 264.431046 L 335.865299 278.112675 L 335.378095 278.112675 L 331.602265 264.431046 Z M 339.64113 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 331.602265 264.431046 L 335.378095 278.112675 L 333.551081 280.832761 L 329.77525 267.191731 Z M 331.602265 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 329.77525 267.191731 L 333.551081 280.832761 L 321.736386 280.832761 L 325.512216 267.191731 Z M 329.77525 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 325.512216 267.191731 L 321.736386 280.832761 L 319.909371 278.112675 L 323.685201 264.431046 Z M 325.512216 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 323.685201 264.431046 L 319.909371 278.112675 L 319.462767 278.112675 L 315.686937 264.431046 Z M 323.685201 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 315.686937 264.431046 L 319.462767 278.112675 L 317.635753 280.832761 L 313.859922 267.191731 Z M 315.686937 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 313.859922 267.191731 L 317.635753 280.832761 L 305.780457 280.832761 L 309.596888 267.191731 Z M 313.859922 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 309.596888 267.191731 L 305.780457 280.832761 L 303.994043 278.112675 L 307.769873 264.431046 Z M 309.596888 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 307.769873 264.431046 L 303.994043 278.112675 L 303.506839 278.112675 L 299.731009 264.431046 Z M 307.769873 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 299.731009 264.431046 L 303.506839 278.112675 L 301.679825 280.832761 L 297.903994 267.191731 Z M 299.731009 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 297.903994 267.191731 L 301.679825 280.832761 L 298.431798 280.832761 L 298.431798 267.191731 Z M 297.903994 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 298.431798 267.191731 L 298.431798 280.832761 L 289.86513 280.832761 L 293.64096 267.191731 Z M 298.431798 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 293.64096 267.191731 L 289.86513 280.832761 L 288.038115 278.112675 L 291.813945 264.431046 Z M 293.64096 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 291.813945 264.431046 L 288.038115 278.112675 L 287.550911 278.112675 L 283.775081 264.431046 Z M 291.813945 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 283.775081 264.431046 L 287.550911 278.112675 L 285.723896 280.832761 L 281.988666 267.191731 Z M 283.775081 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 281.988666 267.191731 L 285.723896 280.832761 L 273.909201 280.832761 L 277.685032 267.191731 Z M 281.988666 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 277.685032 267.191731 L 273.909201 280.832761 L 272.082187 278.112675 L 275.858017 264.431046 Z M 277.685032 267.191731 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 275.858017 264.431046 L 272.082187 278.112675 L 271.635583 278.112675 L 267.859753 264.431046 Z M 275.858017 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 267.859753 264.431046 L 271.635583 278.112675 L 273.381397 275.433187 L 264.286924 269.790023 Z M 267.859753 264.431046 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 264.286924 269.790023 L 273.381397 275.433187 L 273.381397 320.253714 L 264.286924 333.894744 Z M 264.286924 269.790023 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.65421, -2.399813)",
    fillOpacity: 1,
    fill: "#000000",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 264.286924 333.894744 L 273.381397 320.253714 L 275.086611 320.253714 L 271.310781 333.894744 Z M 264.286924 333.894744 ",
    stroke: "#000000",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaling);
export default __webpack_public_path__ + "static/media/Waling.2a2ded0178def42a20684a20b5cb1ab5.svg";
export { ForwardRef as ReactComponent };